import { render, staticRenderFns } from "./PreorderStatistic.vue?vue&type=template&id=598ae239&"
import script from "./PreorderStatistic.vue?vue&type=script&lang=js&"
export * from "./PreorderStatistic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports